module.exports = __webpack_public_path__ + "img/mail.9a9d1928.svg";